/**
 * DEV-1935. Выбор типа документа при загрузке и компактный блок файлов в обзоре.
 */

const ruUploadType = {
  title: 'Тип документа',
  queue: 'Файл {index} из {total}',
  type: 'Что это за документ',
  noType: 'Без типа — обычное вложение',
  noTypeHint: 'Файл просто приложится к сделке: проверка ИИ не проводится.',
  checkHint: 'Документ уйдёт на проверку ИИ — результат появится в списке.',
  checkHintFormats: 'Форматы: {formats}, до 15 МБ. Документ уйдёт на проверку ИИ.',
  wrongFormat: 'Для этого типа принимаются только {formats}',
  tooLarge: 'Файл больше 15 МБ — проверка такой не примет',
  submit: 'Загрузить',
}

const enUploadType = {
  title: 'Document type',
  queue: 'File {index} of {total}',
  type: 'What is this document',
  noType: 'No type — plain attachment',
  noTypeHint: 'The file is simply attached to the deal: no AI check runs.',
  checkHint: 'The document goes to the AI check — the verdict shows up in the list.',
  checkHintFormats: 'Formats: {formats}, up to 15 MB. The document goes to the AI check.',
  wrongFormat: 'This type only accepts {formats}',
  tooLarge: 'The file is over 15 MB — the check will not take it',
  submit: 'Upload',
}

const vnUploadType = {
  title: 'Loại tài liệu',
  queue: 'Tệp {index} / {total}',
  type: 'Đây là tài liệu gì',
  noType: 'Không có loại — tệp đính kèm thường',
  noTypeHint: 'Tệp chỉ được đính kèm vào giao dịch: không chạy kiểm tra AI.',
  checkHint: 'Tài liệu sẽ được AI kiểm tra — kết quả hiện trong danh sách.',
  checkHintFormats: 'Định dạng: {formats}, tối đa 15 MB. Tài liệu sẽ được AI kiểm tra.',
  wrongFormat: 'Loại này chỉ nhận {formats}',
  tooLarge: 'Tệp lớn hơn 15 MB — kiểm tra sẽ không nhận',
  submit: 'Tải lên',
}

const ruFilesCard = {
  title: 'Файлы',
  empty: 'Файлов пока нет',
  dropHint: 'Перетащите файл или нажмите',
  all: 'Все документы →',
}

const enFilesCard = {
  title: 'Files',
  empty: 'No files yet',
  dropHint: 'Drop a file or click',
  all: 'All documents →',
}

const vnFilesCard = {
  title: 'Tệp',
  empty: 'Chưa có tệp',
  dropHint: 'Kéo tệp vào đây hoặc bấm',
  all: 'Tất cả tài liệu →',
}

export const dealFileTypesMessages = {
  ru: { deals: { detail: { uploadType: ruUploadType, filesCard: ruFilesCard } } },
  en: { deals: { detail: { uploadType: enUploadType, filesCard: enFilesCard } } },
  vn: { deals: { detail: { uploadType: vnUploadType, filesCard: vnFilesCard } } },
}
